import { Globe2 } from "lucide-react";
import TimeConverter from "../timeConverter/TimeConverter";

export default function TimeConverterPanel() {
    return (
        <div className="px-4 lg:px-0 py-4 lg:py-0 space-y-4" data-testid="time-converter-panel">
            <div>
                <h2 className="font-heading text-2xl font-bold text-[#0F172A] inline-flex items-center gap-2">
                    <Globe2 className="w-6 h-6 text-[#1E3A8A]" /> International Time Converter
                </h2>
                <p className="text-sm text-slate-600 mt-1">
                    Convert a parent's local time to IST (or IST to their local time) in seconds, then copy a WhatsApp-ready reply.
                </p>
            </div>
            <TimeConverter variant="admin" />
        </div>
    );
}
